module.exports = __webpack_public_path__ + "img/15.ad3a6362.png";